<template>
    <div class="courseware-preview">
        <!-- 免费试听提示弹窗 -->
        <Modal
        v-model="msgModal"
        footer-hide
        title="提示">
            <Nodata v-if="client.buyCourseUrl" :size="100" :type="2" class="no-data">非试听章节，点击<a :href="client.buyCourseUrl" target="_blank">购买</a></Nodata>
            <Nodata v-else :size="100" :type="2" class="no-data">非试听章节</Nodata>
        </Modal>
        <!-- 题目弹窗-->
        <Modal ref="modal" v-model="questionVideoModal" title="测评题" :closable="false" :mask-closable="false" footer-hide class="preview-modal" @on-visible-change="colseModal">
            <!-- 题型 -->
            <div class="question-stem-preview">
                <span class="question-stem-content-preview">{{ baseTypeLabel }}</span>
            </div>
            <!-- 题干 -->
            <div class="question-stem-preview">
                <span v-if="question.snLabel" class="sn-label-preview">{{ question.snLabel }}</span>
                <span class="question-stem-content-preview" v-html="question.questionStem"/>
            </div>
            <!-- 选项 1: 单选题和多选题 -->
            <div class="question-options">
                <div v-for="(option, index) in question.optionList" :key="index" :class="{ correct: option.checked }" class="question-option">
                    <div :class="{ correct: option.checked }" class="mark" @click="chooiceAnswer(question, index)">{{ option.quesValue }}</div>
                    <div v-html="option.quesOption" class="option-list"></div>
                </div>
            </div>
            <!-- 解析 -->
            <div class="question-analysis-preview-box" v-show="showAnalysis">
                <div class="question-analysis-preview">
                    <div class="positiveSolution"></div>
                    <span class="title-desc-preview">【解析】</span>
                    <div class="question-analysis-content-preview" v-html="question.analysis"></div>
                </div>
                <!-- 考核点 -->
                <div class="question-knowledge-point-preview">
                    <span class="title-desc-preview">【考核点】</span>
                    <div class="question-analysis-content-preview" v-html="question.examinePoint"></div>
                </div>
            </div>
            <div class="button-box-preview">
                <Button v-if="buttonType == 1" type="primary" @click="sumbitAnswer">提交</Button>
                <Button v-else type="primary" @click="videoCancel">关闭</Button>
            </div>
        </Modal>
        <h3 id="h3">{{mediaTitle}}</h3>
         <dl class="mediaDuration">
            <dt>{{name}}</dt>
            <dd>总时长：{{duration}}</dd>
        </dl>
        <div class="video-conct">
            <div class="video-box">
                <div class="prism-player" id="J_prismPlayer"></div>
            </div>
            <div class="video-nav">
                <div class="video-box-right">
                    <div @click="changeType(1)" :class="{actived: type == 1}" style="float: left;"><Icon type="md-reorder"/><span>目录</span></div>
                    <div v-if="nodeData.lectures.length > 0" @click="changeType(2)" :class="{actived: type == 2}"><Icon type="ios-book-outline"/><span>讲义</span></div>
                    <div v-if="nodeData.catalogKnowledgePoints.length > 0" @click="changeType(3)" :class="{actived: type == 3}"><Icon type="ios-bulb-outline"/><span>知识点</span></div>
                </div>
                <div class="video-box-left">
                    <div class="fold">></div>
                    <Tree v-if="type == 1" :data="chapters" :render="renderContent"></Tree>
                    <div v-if="type == 2" class="brief handout">
                    <ul v-if="nodeData.lectures.length > 0" class="handout-list">
                        <li v-for="(site,index) in nodeData.lectures" :key="index">
                            <p class="title">讲义{{ index+1 }}<span class="minute">{{ initTime(site.startTime) }}</span>-<span class="second">{{ initTime(site.endTime) }}</span></p>
                            <div v-html="site.content"/>
                            <h1></h1>
                        </li>
                    </ul>
                    <Nodata v-else :size="100" :type="2" class="no-data">该章节暂无讲义,请编辑课件</Nodata>
                </div>
                <div v-if="type == 3" class="brief knowledge-points">
                    <ul v-if="nodeData.catalogKnowledgePoints.length > 0" class="knowledge-points-list">
                        <li v-for="(site,index) in nodeData.catalogKnowledgePoints" :key="index">
                            <p class="title">知识点{{ index+1 }}<span>{{ initTime(site.startTime) }}-{{ initTime(site.endTime) }}</span></p>
                            <div class="points">
                            <span v-for="(point, index) in site.knowledgePoints" :key="index"> {{ point.title }}</span>
                            </div>
                        </li>
                    </ul>
                    <Nodata v-else :size="100" :type="2" class="no-data">该章节暂无知识点,请编辑课件</Nodata>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            questionModal: false,
            questionVideoModal: false,
            type: 1, // 1:章节目录 2:讲义 3:知识点
            chapters: [],
            coursewareCode: '',
            nodeData: {},
            pointsTime:'', // 创建知识点
            answer:'',     // 创建答题点
            questionsOpen: [], // 当前章节所有弹题
            question: {},
            analysisInvisible: false,
            lectures:[], // 当前章节所有讲义
            timers: null,
            mediaTitle: '',
            name:'',
            duration:'',
            uploadedFileUrl:'',
            chapterId: '',
            chapterIds: '',
            msgModal: false,
            freeChapter: {}, // 免费章节
            buttonType: 1,
            showAnalysis: false,        // 查看题目解析
            rightAnswers: [],            // 正确答案
            client: null,
            /*client: {
                coursewareCode: '1745_ept',
                userId: '111',
                userName: '张三',
                clientCode: '852013',
                businessLineCode: 'ld_gk',
                courseCode: '00009',
                backUrl: 'http://jd.edu-edu.com.cn/index.php?r=operation/AutoPicCreate/IearnRecords',
                catalogIds: '314972010637688832, 314972013166854145',
                buyCourseUrl: 'http://www.baidu.com',
            },*/
        };
    },
    created() {
        // 获取 cookie 中听课记录
        this.checkClickAuth();
        // 修改根据Id查询课件信息
        if (this.client != null && this.client.coursewareCode) {
            this.coursewareCode = this.client.coursewareCode;
            this.findChaptersByCoursewareCode();
            this.findCoursewareByCode();
        }
        var _this = this;
        document.title = this.name;
        document.onkeydown = function(e) {
            let key = window.event.keyCode;
            if (key == 32 && player.getStatus() != 'pause') {
                player.pause();
            } else if (key == 32) {
                player.play();
            }
        };
    },
    computed: {
        // 题型
        baseTypeLabel() {
            for (let type of QuesstionType) {
                if (this.question.questionType == type.value) {
                    return type.label;
                }
            }
            return '';
        },
    },
    mounted() {
        // 播放器初始化
        $(function () {
            window.popped = false;
            window.player = new Aliplayer({
                showBarTime:'5000000000',
                id: 'J_prismPlayer',
                width: '100%',
                enableSystemMenu: true,
                autoplay: false,
                preload: true,
                useH5Prism: true,
                // 视频播放路径(当视频不为阿里云视频的时候使用)
                source: '',
                // 阿里云视频参数(阿里云视频使用 vid、playauth 获取视频播放)
                vid : '',
                playauth : '',
                // 视频封面
                cover: '',
                format: 'm3u8',
                skinLayout:[
                    {
                        name: 'controlBar', align: 'blabs', x: 0, y: 0,
                        children: [
                            {
                                name: 'progress', align: 'blabs', x: 0, y: 44
                            },
                            {
                                name: 'playButton', align: 'tl', x: 15, y: 12
                            },
                            {
                                name: 'timeDisplay', align: 'tl', x: 10, y: 7
                            },
                            {
                                name: 'fullScreenButton', align: 'tr', x: 10, y: 12
                            },
                            {
                                name:'setting', align:'tr', x:15, y:12
                            },
                            {
                                name: 'volume', align: 'tr', x: 5, y: 10
                            },
                            {
                                name: 'display', align: 'tr', x: 5, y: 10
                            },
                        ]
                    }
                ]
            }, function(player) {
            });
        });
        // 播放用户选择的视频
        if (JSON.stringify(this.nodeData) != '{}') {
            this.changeMediaUrl(this.nodeData, 1);
        }
    },
    methods: {
        initTime(time) {
            return Utils.getTime(time);
        },
        renderContent (h, { root, node, data }) {
            let color = data.free == 1 ? '#19be6b' :  '';
            color = data.id == this.nodeData.id ? '#5c77fb' : color;
            return (
                <span class="render-content">
                    <span id={ data.id } class="tree-node" style={ `color: ${color}`  } onClick={() => { this.changeMediaUrl(data); }} >{ data.title }</span>
                </span>
            );
        },
        // 清除定时任务
        clearTimeOuts() {
            // 清楚上个视频的弹题、讲义、知识点的定时任务
            clearTimeout(this.timers);
            this.timers = null;
        },
        //  切换视频
        changeMediaUrl(data) {
            // 不是免费章节不让播放
            if (data.free != 1) {
                this.msgModal = true;
                return;
            }
            // 根据当前章节查询讲义、弹题、知识点
            this.changeCode(data);
            // 判断当前节点是否是视频
            if (this.nodeData.isMedia != 1) {
                // 创建空的播放器
                this.endedHandle(2, '', '', '');
                return;
            }
            // 删除所有创建答题点
            $('.point').remove();
            // 删除所有创建的知识点
            $('.importantb').remove();
            //判断视频播放类型
            if (this.nodeData.media.serverType.indexOf('aliyunCode') == -1) {
                if (this.nodeData.media.mediaSource.indexOf('http') !=-1) {
                    //HTTP播放(用户输入完整路径http:***)
                    this.endedHandle(2, this.nodeData.media.mediaSource, '', '');
                } else {
                    //HTTP播放（无域名的路径）
                    this.endedHandle(2, this.nodeData.media.serverCluster + '/' + this.nodeData.media.mediaSource + '_sd.mp4', '', '');
                }
                player.play();
            } else {
                //阿里云ID播放
                this.endedHandle(1, '', this.nodeData.media.mediaSource, this.nodeData.media.playAuth);
            }
            // 初始化进度
            player.seek(0.1);
        },
        endedHandle(type, source, vid, newPlayAuth) {
            let cover = '';
            if (this.nodeData.media) {
                cover = this.nodeData.media.coverURL;
            }
            player.dispose(); //销毁
            // 1.指定类型 playType 播放课件时, 使用 playType 类型播放
            // 2.未指定类型 playType 播放课件时, 判断是自己的阿里账号播放则 为 m3u8, 其他账号时为 Mp4
            if (this.nodeData.media.serverType && this.nodeData.media.serverType === 'aliyunCode') {
                this.nodeData.media.playType = 'm3u8';
            } else {
                this.nodeData.media.playType = 'mp4';
            }
            player.dispose();
            // id为html里指定的播放器的容器id
            // $('#J_prismPlayer').empty();
            $('.video-box').empty().append('<div class="prism-player" id="J_prismPlayer"></div>');
            let flag = true;
            if (type != 1) {
                flag = false;
            }
            //重新创建
            player = new Aliplayer({
                showBarTime:'5000000000',
                id: 'J_prismPlayer',
                width: '100%',
                enableSystemMenu: true,
                autoplay: flag,
                preload: true,
                useFlashPrism: false,
                playsinline:true,
                vid: vid,
                playauth: newPlayAuth,
                source: source,
                format: this.nodeData.media.playType,
                cover: cover,
                skinLayout:[
                    {
                        name: 'controlBar', align: 'blabs', x: 0, y: 0,
                        children: [
                            {
                                name: 'progress', align: 'blabs', x: 0, y: 44
                            },
                            {
                                name: 'playButton', align: 'tl', x: 15, y: 12
                            },
                            {
                                name: 'timeDisplay', align: 'tl', x: 10, y: 7
                            },
                            {
                                name: 'fullScreenButton', align: 'tr', x: 10, y: 12
                            },
                            {
                                name:'setting', align:'tr', x:15, y:12
                            },
                            {
                                name: 'volume', align: 'tr', x: 5, y: 10
                            },
                            {
                                name: 'display', align: 'tr', x: 5, y: 10
                            },
                        ]
                    }
                ]
            }, function(player) {
            });
            //点击折叠框
            var fold = 0;
            $('.fold').click(function() {
                fold += 1;
                if (fold%2==0) {
                    $('.video-box-right').show();
                    $('.video-nav').animate({
                        width : '25vw'
                    });
                    $('.video-box').animate({
                        width : '74vw'
                    });
                    $(this).html('>');
                } else {
                    $(this).html('<');
                    $('.video-box-right').hide();
                    $('.video-nav').animate({
                        width : '1vw',
                    });
                    $('.video-box').animate({
                        width : '98vw',
                    });
                }
            });
            var self = this;
            // 创建弹题点
            function createQuestionPointAliyun() {
                // 知识点
                var pointsTime = self.pointsTime.split(',');
                // 获取视频时长
                var duration = $('video').get(0).duration;
                for (var j =0; j <pointsTime.length-1; j++) {
                    var importantbStart = pointsTime[j].split('+')[0]/ duration*100;
                    // 知识点结束距离左边距离
                    var importantbEnd = pointsTime[j].split('+')[1] / duration*100;
                    var importantbWidth = importantbEnd - importantbStart;
                    $('.prism-controlbar').append(`<div class="importantb" style="left: ${importantbStart}%;width:${importantbWidth}%"></div>`);
                }
                for (var m=0; m<self.answer.length; m++) {
                    // 创建答题点
                    var left = self.answer[m] / duration*100;
                    $('.prism-controlbar').append(`<div class="point" style="left: ${left}%" data-time="${left}"></div>`);
                }
            }
            function getTimes() {
                $('.handout .handout-list li').removeClass('active');
                $('.knowledge-points .knowledge-points-list li').removeClass('actives');
                var currentTime = parseInt(player.getCurrentTime());
                self.timers = setTimeout(getTimes, 1000);
                if (player.getStatus() == 'playing') {
                    createQuestionPointAliyun();
                }
                //讲义联动
                for (var m=0; m<self.nodeData.lectures.length; m++) {
                    if (self.nodeData.lectures[m].startTime<=currentTime && self.nodeData.lectures[m].endTime>=currentTime) {
                        $('.handout .handout-list li').removeClass('active');
                        $('.handout .handout-list li').eq(m).addClass('active');
                    }
                }
                //知识点联动
                for (var s=0; s<self.nodeData.catalogKnowledgePoints.length; s++) {
                    if (self.nodeData.catalogKnowledgePoints[s].startTime<=currentTime && self.nodeData.catalogKnowledgePoints[s].endTime>=currentTime) {
                        $('.knowledge-points .knowledge-points-list li').removeClass('actives');
                        $('.knowledge-points .knowledge-points-list li').eq(s).addClass('actives');
                    }
                }
                for (var b=0; b<self.questionsOpen.length; b++) {
                    var positiveSolution='';
                    if (self.questionsOpen[b].flag && self.questionsOpen[b].mediaTime == currentTime) {
                        // 将题目的选项选中状态去掉
                        self.rightAnswers = [];
                        for (var c= 0; c<self.questionsOpen[b].optionList.length; c++) {
                            if (self.questionsOpen[b].optionList[c].correct==true) {
                                positiveSolution+=self.questionsOpen[b].optionList[c].quesValue+' ';
                                self.rightAnswers.push(self.questionsOpen[b].optionList[c].quesValue);
                            }
                        }
                        $('.positiveSolution').html('【答案】'+positiveSolution);
                        for (let options of self.questionsOpen[b].optionList) {
                            self.$set(options, 'checked', false);
                        }
                        self.question = self.questionsOpen[b];
                        self.questionVideoModal = true;
                        self.questionsOpen[b].flag = false;
                        player.pause();
                    }
                }
            }
            // 播放记录
            /*************************/
            var video = document.getElementsByTagName('video');
            /*
             * 1.点击开始播放
             * 2.获取视频时长
             * 3.创建答题节点
             * 4.创建知识点
            */
            function myFunction() {
                var index =0;
            }
            $(document).on('click', '.point', (event) => {
                // 将题目的弹题状态置位true
                self.questionsOpen.forEach(q => q.flag = true);
                var duration = $('video').get(0).duration;
                var thisTime = $(event.target).attr('data-time')/100*duration;
                // 调整进度
                player.seek(Math.round(thisTime));
                self.questionVideoModal = true;
                player.pause();
            });
            // 滑过进度条，调整追加元素样式
            $('.prism-progress').hover(function() {
                $('.importantb').css({ 'height':'10px', 'top':'-6px' });
                $('.point').css({ 'width':'15px', 'height':'15px', 'top':'-8px' });
            }, function() {
                $('.importantb').css({ 'height':'4px', 'top':'0px' });
                $('.point').css({ 'width':'10px', 'height':'10px', 'top':'-3px' });
            });
            // 点击讲义列表
            $(document).on('click', '.handout .handout-list li', (event) => {
                var minute = $(event.target).parent().find('.title').find('.minute');
                var second = $(event.target).parent().find('.title').find('.second');
                minuteTime=parseInt(minute.html().split(':')[0])*3600+parseInt(minute.html().split(':')[1])*60+parseInt(minute.html().split(':')[2]);
                secondTime=parseInt(second.html().split(':')[0])*3600+parseInt(second.html().split(':')[1])*60+parseInt(second.html().split(':')[2]);
                $('.handout .handout-list li').removeClass('active');
                $(event.target).parents('li').addClass('active');
                // 调整进度
                player.seek(minuteTime);
            });
            player.on('play', function (e) {
                getTimes();
            });
            // 拖拽进度条前回传听课记录
            player.on('startSeek', function(e) {
                // 将当前视频的所有题的弹题状态变为true
                self.questionsOpen.forEach(q => q.flag = true);
            });
            $('.prism-controlbar').append('<a download class="file-download"></a>');
            $('.file-download').attr('href', self.uploadedFileUrl);
            if (self.client.clientCode === '579250') {
                $('.prism-controlbar').append('<div class="error-courseware">纠错</div>');
                $('.error-courseware').on('click', function () {
                    window.open(`http://www.edu-edu.com/survey/insert/correct/110/1122280?coursewareName=${self.name}`);
                });
                $('.prism-controlbar').append('<div class="comment-courseware">评课</div>');
                $('.comment-courseware').on('click', function () {
                    window.open(`http://www.edu-edu.com/survey/surveys/0?coursewareName=${self.name}&coursewareId=${self.coursewareId}&accountId=${self.client.userId}`);
                });
            }
        },
        // 根据code查询课件
        findCoursewareByCode () {
            this.name = '';
            this.duration='';
            this.uploadedFileUrl='';
            let param = {};
            this.$ClientDao.findCoursewareByCode(this.coursewareCode, param, (courseware) => {
                if (courseware) {
                    this.name= courseware.name;
                    this.duration= Utils.getTime(courseware.duration);
                    if (courseware.uploadedFile) {
                        this.uploadedFileUrl=courseware.uploadedFile.url;
                    }
                }
            });
        },
        // 根据课件 code 查询章节
        findChaptersByCoursewareCode() {
            let client = {
                coursewareCode: this.coursewareCode,
                clientCode: this.client.clientCode,
                userId: this.client.userId,
            };
            this.$ClientDao.findCoursewareByCilent(client, (chapters) => {
                if (chapters.length > 0) {
                    let chapterIds = this.chapterIds ? this.chapterIds : this.chapterId;
                    let freeCount = 0;
                    let freeList = chapters.map(x => {
                        if (chapterIds && chapterIds.indexOf(x.id) > -1) {
                            x.free = 1;
                            freeCount += 1;
                        }
                        return x;
                    });
                    // 免费章节有章节 id 播放指定视频没有播放第一个视频
                    if (freeCount == 0) {
                        freeList[0].free = 1;
                        this.freeChapter = freeList[0];
                    } else {
                        let index = freeList.findIndex(x => x.free == 1);
                        this.freeChapter = freeList[index];
                    }
                    this.rebuildTree(freeList);
                }
            });
        },
        // 重组树结构
        rebuildTree(chapters) {
            let newTree = [];
            // 找到每个节点的子节点
            for (let tree of chapters) {
                tree.children = [];
                tree.expand = true;
                for (let child of chapters) {
                    if (child.pId == tree.id) {
                        tree.children.push(child);
                    }
                }
            }
            // 过滤掉除第一节点外的数据
            newTree = chapters.filter(x => x.pId == 0);
            this.chapters.push(...newTree);
            // 选中当前章节
            this.changeCode(this.freeChapter);
        },
        // 改变章节重置对象
        changeCode(data) {
            this.nodeData = data;
            // 准备查询讲义、题目、知识点
            this.nodeData.lectures = [];
            this.nodeData.catalogKnowledgePoints = [];
            this.nodeData.questions = [];
            // 是媒体查询媒体信息
            if (this.nodeData.isMedia == 1) {
                this.findLecturesMediaKnowledgePointsQuestions();
            }
        },
        compare(property) {
            return function(a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            };
        },
        // 根据课件编码和章节 ID 及媒体 ID 获取讲义/知识点/弹题列表
        findLecturesMediaKnowledgePointsQuestions() {
            this.pointsTime = '';
            this.answer = [];
            this.questionsOpen= [];
            this.nodeData.lectures= [];
            this.mediaTitle= '';
            this.nodeData.catalogKnowledgePoints=[];
            let client = {
                clientCode: this.client.clientCode,
                userId: this.client.userId,
                isQuestion: this.client.isQuestion,
                coursewareCode: this.coursewareCode,
            };
            this.$ClientDao.findLecturesMediaKnowledgePointsQuestions(this.nodeData.id, client, (catalog) => {
                this.mediaTitle=catalog.title;
                if (catalog) {
                    // 获取媒体
                    if (catalog.media) {
                        this.nodeData.media = catalog.media;
                    }
                    // 获取讲义
                    if (catalog.lectures.length > 0) {
                        this.nodeData.lectures.push(...catalog.lectures.sort(this.compare('startTime')));
                    }
                    // 获取知识点
                    if (catalog.catalogKnowledgePoints.length > 0) {
                        this.nodeData.catalogKnowledgePoints.push(...catalog.catalogKnowledgePoints.sort(this.compare('startTime')));
                        var pointsTime='';
                        for (var i=0; i<this.nodeData.catalogKnowledgePoints.length; i++) {
                            pointsTime+= this.nodeData.catalogKnowledgePoints[i].startTime+'+'+this.nodeData.catalogKnowledgePoints[i].endTime+',';
                        }
                        this.pointsTime=pointsTime;
                    }
                    // 获取弹题
                    if (catalog.questions.length > 0) {
                        this.nodeData.questions.push(...catalog.questions);
                        this.answer = this.nodeData.questions.map(x => x.mediaTime);
                        for (let question of this.nodeData.questions) {
                            this.$set(question, 'flag', true);
                            this.questionsOpen.push(question);
                        }
                    }
                }
            });
        },
        // 视频弹窗点击确定
        videoAnswer() {
            // 发送数据后台验证
            this.$refs.modal.close();
        },
        // 视频弹窗点击取消
        videoCancel() {
            this.$refs.modal.close();
        },
        colseModal(value) {
            if (!value) {
                player.play();
                this.buttonType = 1;
                this.showAnalysis = false;
            }
        },
        changeType(type) {
            this.type = type;
        },
        // 标记选项为正确的或者错误的
        chooiceAnswer(question, optionIndex) {
            if (this.readOnly) { return; }
            this.$QuestionUtils.chooiceAnswer(question, optionIndex);
        },
        // 校验第三方用户权限
        checkClickAuth() {
            // 获取 cookie 和 url 中的信息
            let uId = this.$route.query.uid;
            let str = Utils.getCookie(uId);
            let errorMsg = decodeURIComponent(this.$route.query.errorMsg);
            if (str && errorMsg == 'undefined') {
                this.client = JSON.parse(JSON.parse(str));
                this.chapterId = this.client.catalogId;
                this.chapterIds = this.client.catalogIds;
            } else {
                let errorMsg = decodeURIComponent(this.$route.query.errorMsg);
                // 跳转错误页
                this.$router.push({
                    name: 'player-error',
                    params: {
                        error: errorMsg
                    }
                });
            }
        },
        // 弹题答案提交
        sumbitAnswer() {
            // 过滤学生选择的答案
            let checkList = this.question.optionList.filter(x => x.checked == true);
            if (checkList.length > 0) {
                this.buttonType = 2;
                this.showAnalysis = true;
            } else {
                this.$Message.warning('请作答!');
            }
        }
    },
};

</script>

<style lang="scss">
.courseware-preview{
    position: relative;
    overflow: hidden;
    .prism-player .prism-big-play-btn{
        display: none!important;
    }
    h3{
        height: 60px;
        line-height: 60px;
        color: #b0b6d6;
        padding-left: 20px;
        font-size: 16px;
        background: #333749;
    }
    .mediaDuration{
        position: absolute;
        top: 20px;
        right: 0;
        padding-right: 30px;
        dt{
            font-size: 18px;
            font-weight: bold;
            color: #b0b6d6;
            float: left;
        }
        dd{
            padding-top: 3px;
            font-size: 14px;
            color: #b0b6d6;
            float: left;
            padding-left: 30px;
        }
    }
    .ivu-split-trigger-vertical{
        background: black;
        border:none;
    }
    .ivu-split-trigger-vertical .ivu-split-trigger-bar{
        background: #fff;
    }
    .video-conct{
        background:#222638;
        height:92vh;
    }
    .video-box{
        width: 74vw;
        height: 92vh;
        float: left;
        #J_prismPlayer{
            height: 100%!important;
        }
    }
    .video-nav{
        float: right;
        width: 25vw;
        height: 92vh;
        position: relative;
        .video-box-right{
            text-align: center;
            width: 100%;
            background: #2a2e41;
            padding-top: 12px;
            div{
                display: inline-block;
                padding: 0px 10px;
                margin: 0px 10px;
                span{
                    position: relative;
                    top: 2px;
                    color: #6d728c;
                    cursor: pointer;
                    padding-left: 5px;
                    font-size: 16px;
                }
            }
            .ivu-icon{
                font-size: 28px;
                color: #6d728c;
                cursor:pointer;
            }
            .actived {
                color: #b0b6d6;
                border-bottom: 3px solid #b0b6d6;
                padding-bottom: 8px;
                .ivu-icon{
                    color: #b0b6d6;
                }
                span{
                    color: #b0b6d6;
                }
            }
        }
        .video-box-left{
            height: 88vh;
            width: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 16px;
            color: #b0b6d6;
            position: relative;
            .ivu-tree ul li{
                cursor:pointer;
                font-size: 14px;
            }
             .global-nodata {
                display: flex;
                height: 100%;
                .description {
                    color: white;
                }
            }
            .fold{
                display: inline-block;
                position: absolute;
                left: 0px;
                width: 12px;
                text-align: center;
                height: 60px;
                background: #333749;
                line-height: 60px;
                border-radius: 0px 5px 5px 0px;
                top: 40%;
                margin-top: -30px;
                cursor: pointer;
            }
        }
        .brief{
            .handout-list{
                .active{
                    border: 1px solid red;
                }
                li{
                    list-style: none;
                    border: 1px solid #515a6e;
                    padding: 8px;
                    margin-bottom: 16px;
                    cursor:pointer;
                    position: relative;
                    p{
                        word-break: break-all;
                        padding-bottom: 8px;
                        span{
                            padding-left: 5px;
                            padding-right: 5px;
                        }
                    }
                    h1{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        z-index: 2;
                    }
                }
            }
            .knowledge-points-list{
                .actives{
                    border: 1px solid #fff;
                }
                li{
                    list-style: none;
                    border: 1px solid #515a6e;
                    padding: 8px;
                    margin-bottom: 16px;
                    cursor:pointer;
                    position: relative;
                    p{
                        padding-bottom: 8px;
                        span{
                            padding-left: 5px;
                            padding-right: 5px;
                        }
                    }
                    h1{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        z-index: 2;
                    }
                }
            }
        }
    }
    .prism-controlbar{
        bottom: 10px!important;
    }
    .point {
        position: absolute;
        top: -3px;
        width: 10px;
        height: 10px;
        border: 1px solid blue;
        border-radius: 50%;
        background: red;
        z-index: 100000;
        cursor:pointer;
    }
    .points span{
            display: inline-block;
            padding: 5px 10px;
    }
    .importantb{
       position: absolute;
       top: 0px;
       height: 4px;
       left: 400px;
       background: red;
       width: 50px;
    }
    .point:hover {
        border: 1px solid white;
        background: orange;
    }
    .prism-controlbar{
        display: block!important;
    }
    .prism-progress-cursor{
        z-index: 5;
    }
    // 评课
    .error-courseware, .comment-courseware {
        display: block;
        height: 30px;
        width: 30px;
        background-color: $successColor;
        border-radius: 30px;
        margin-top: 12px!important;
        float: right;
        margin-right: 5px;
        font-size: 10px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor:pointer;
    }
}
.render-content {
    .tree-node {

    }
    .active {
        color: $primaryColor;
    }
}
.question-stem-preview{
    padding-bottom: 10px;
}
.options-content-preview{
    .question-option-preview{
        cursor:pointer;
        overflow: hidden;
        padding-left: 14px;
        padding-bottom: 10px;
        .ivu-radio{
            float: left;
            margin-top: 3px;
        }
        .option-content-preview{
            float: left;
            height: 20px;
            line-height: 20px;
        }
    }
    .check-box-group {
        display: block;
        margin-bottom: 10px;
    }
}
.button-box-preview{
        text-align: center;
}
.options-content-preview{
    padding-top: 10px;
}
.question-analysis-preview{
    padding-left: 10px;
}
.question-knowledge-point-preview{
    padding-left: 10px;
}
.question-analysis-preview-box{
}
// 问题的选项
    .question-options {
        flex: 1;

        // 单选题、多选题选项
        .question-option {
            display: flex;
            margin-bottom: $gap;
            &:hover {
                .mark {
                    color: white;
                    background: $primaryColor;
                }
            }

            // 单选题、多选题选项的标记 A, B, C, D
            .mark {
                // 圆形
                min-width : $optionWidth;
                min-height: $optionWidth;
                max-width : $optionWidth;
                max-height: $optionWidth;
                border-radius: 50%;
                margin-right: $gap;
                @include alignCenter;
                border: 1px solid $separatorColor;
                cursor: pointer;

                // 正确选项
                &.correct {
                    color: white;
                    background: $primaryColor;
                }
            }
            .option-list {
                line-height: 28px;
            }
        }

        // 判断题
        &.question-optioins-tfng {
            display: flex;

            // 判断题的答案按钮
            .question-optioin-tfng {
                @include alignCenter;
                width: 70px;
                height: $optionWidth - 2;
                border: $optionBorder;
                border-radius: $borderRadius;
                cursor: default;

                // 正确答案按钮
                &.correct {
                    color: white;
                    background: $primaryColor;
                    border-color: $primaryColor;
                }

                // 左边按钮
                &:first-child {
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    border-right-width: 0;
                    margin-right: 0;
                }

                // 右边按钮
                &:last-child {
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    border-left-width: 0;
                }
            }
        }
    }
.prism-player {
        .prism-time-display .current-time{
            color: #00c1de;
        }
        .prism-play-btn {
            background: url("/static/img/play-img/smallplay.png") no-repeat;
            background-size: contain;
        }
        .prism-play-btn.playing {
            background: url("/static/img/play-img/smallpause.png") no-repeat;
            background-size: contain;
        }
        .file-download {
            display: block;
            height: 30px;
            width: 30px;
            margin-top: 12px!important;
            float: right;
            margin-right: 5px;
            background: url("/static/img/play-img/download.png") no-repeat;
        }
        .prism-volume .volume-icon{
            background: url("/static/img/play-img/volume.png") no-repeat;
            background-size: contain;
            .short-horizontal {
                background: #00c1de;
            }
            .long-horizontal {
                background: #00c1de;
            }
        }
        .prism-setting-btn {
            background: url("/static/img/play-img/setting.png") no-repeat;
            background-size: contain;
        }
        .prism-fullscreen-btn {
            background: url("/static/img/play-img/fullscreen.png") no-repeat;
            background-size: contain;
        }
        .prism-fullscreen-btn.fullscreen {
            background: url("/static/img/play-img/smallscreen.png") no-repeat;
                background-size: contain;
        }

    }
.title-desc-preview, .positiveSolution {
    font-weight: bold;
}
</style>
